module.exports = __webpack_public_path__ + "img/00_Sperrzone_iPad_L.3eee9e61.jpg";